'use client';

import { type FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { UseAbTestingCookiesFromEpsFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseAbTestingCookiesFromEpsFragmentFragmentDoc';
import type { UseOdoscopeCookieFromEpsFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseOdoscopeCookieFromEpsFragmentFragmentDoc';
import type { Device } from '@packages/shared/src/utils/types';
import { useAbTestingCookiesFromEps } from '@packages/search/src/hooks/useAbTestingCookiesFromEps';
import { useOdoscopeCookieFromEps } from '@packages/search/src/hooks/useOdoscopeCookieFromEps';
import { usePersonalizationCookie } from '@packages/search/src/hooks/usePersonalizationCookie';
import { useOdoscopeAttribution } from '@packages/search/src/hooks/useOdoscopeAttribution';
import { useScrollRestoration } from '@packages/shared/src/hooks/useScrollRestoration/useScrollRestoration';

export type SharedPageEffectsProps = {
  maskedData?: FragmentType<typeof UseAbTestingCookiesFromEpsFragmentFragmentDoc> &
    FragmentType<typeof UseOdoscopeCookieFromEpsFragmentFragmentDoc>;
  device: Device;
};

export const SharedPageEffects: FC<SharedPageEffectsProps> = ({ maskedData, device }) => {
  usePersonalizationCookie(device);
  useAbTestingCookiesFromEps(maskedData);
  useOdoscopeCookieFromEps(maskedData);
  useOdoscopeAttribution();
  useScrollRestoration();

  return null;
};
